import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router';
import { useAuth } from '../auth/AuthAllapot.tsx';
import { megerositesParam } from '../auth/belepes.ts';
import { supabase } from '../lib/supabase.ts';
import { Gomb } from '../ui/elemek.tsx';
import BelepesKeret from './BelepesKeret.tsx';

export default function BelepesMegerosites() {
  const hely = useLocation();
  const navigate = useNavigate();
  const { frissites } = useAuth();
  const param = megerositesParam(hely.search);
  const [toltes, setToltes] = useState(false);
  const [hiba, setHiba] = useState<string | null>(null);

  if (!param) {
    return (
      <BelepesKeret cim="Hibás link">
        <p>A link hibás vagy hiányos. Kérj új belépési linket.</p>
        <Link to="/belepes" className="text-kiemelt underline">Vissza a belépéshez</Link>
      </BelepesKeret>
    );
  }
  const meghivas = param.tipus === 'invite';

  // A tokent csak gombnyomásra váltjuk be, így a levelezők linkellenőrzője nem használja el.
  async function bevalt() {
    if (!param) return;
    setToltes(true);
    setHiba(null);
    const { error } = await supabase.auth.verifyOtp({ token_hash: param.tokenHash, type: param.tipus });
    if (error) {
      setToltes(false);
      setHiba(meghivas
        ? 'A meghívó lejárt vagy már felhasználták. Ha még nem léptél be, kérj új meghívót az irodavezetődtől; ha már igen, kérj belépési linket.'
        : 'A link lejárt vagy már felhasználták. Kérj új belépési linket.');
      return;
    }
    await frissites();
    navigate('/belepes/mfa', { replace: true });
  }

  return (
    <BelepesKeret cim={meghivas ? 'Meghívás az irodai felületre' : 'Belépés'}>
      <p className="text-szoveg-halk">
        {meghivas ? 'Meghívtak az irodai felületre. A folytatáshoz fogadd el a meghívást.' : 'A belépéshez kattints a gombra.'}
      </p>
      <Gomb toltes={toltes} onClick={() => void bevalt()}>{meghivas ? 'Meghívás elfogadása' : 'Belépés'}</Gomb>
      {hiba && (
        <div className="grid gap-2">
          <p role="alert" className="rounded-xl border border-hiba bg-hiba-hatter px-3.5 py-2.5 text-sm text-hiba">{hiba}</p>
          <Link to="/belepes" className="text-kiemelt underline">Új belépési link kérése</Link>
        </div>
      )}
    </BelepesKeret>
  );
}
